
<div class="row border-right mb-3" *ngIf="model.getSummary() != undefined" style="max-height:70vh;overflow:auto">
    <div class="col-12 bg-white px-0" *ngIf="model.getSummary()!.FatturaElettronicaBody != undefined">
        <div class="container"  *ngIf="model.getSummary()!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ImportoTotaleDocumento !=''">
            <div class="row px-2 py-2 border-bottom" >
                <div class="col-12" >
                    <span class="font-weight-bold d-block text-left">
                            {{'invoices.edit.documentData.other.tot' | translate}}
                        </span>
                </div>
                <div class="col-12" >
                    <span *ngIf="model.getSummary()!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ImportoTotaleDocumento !=''" 
                        class="d-block text-right font-weight-bold">{{model.getSummary()!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ImportoTotaleDocumento }} €</span>
                </div>
            </div>
                    <div class="row px-2 py-2 border-bottom" *ngFor="let riepilogo of model.getSummary()!.FatturaElettronicaBody.DatiBeniServizi.DatiRiepilogo">
                            <div class="col-12" >
                                <span>{{ ((riepilogo.AliquotaIVA!="" && riepilogo.AliquotaIVA !="0.00") ? 'invoices.edit.riepilogo.totTaxable' : 'invoices.edit.riepilogo.totNotTaxable') | translate }}</span>
                                <br><span [innerText]='(riepilogo.AliquotaIVA!="" && riepilogo.AliquotaIVA !="0.00") ? " (IVA " + riepilogo.AliquotaIVA + "%)" : " ( IVA 0% "+riepilogo.Natura +")"'></span>
                            </div>
                            <div class="col-12 text-right">
                                <span class="" [innerText]='FormatNumber(riepilogo.ImponibileImporto) + " €"'></span>
                            </div>
                    </div>
                    <!--cassa-->
                    <div class="row px-2 py-2 border-bottom" *ngIf="model.getSummary()!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale.length > 0 ">
                        <div class="col-12">
                           {{'invoices.edit.riepilogo.pensionFounds' | translate}}:
                        </div>
                        <div class="col-12 text-right">
                            <span class="d-block" *ngFor="let cassa of model.getSummary()!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiCassaPrevidenziale;"
                                [innerText]='FormatNumber(cassa.ImportoContributoCassa) +" €" + " " + cassa.TipoCassa'><br></span>  
                        </div>
                    </div>

                    <div class="row px-2 py-2 border-bottom">
                        <div class="col-12">
                        {{'invoices.edit.documentData.other.tot' | translate}}: 
                        </div>
                        <div class="col-12 text-right">
                            <span class="">{{FormatNumber(model.getSummary()!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ImportoTotaleDocumento)}}</span> €
                        </div>
                    </div>
                    <!-- ritenuta-->
                    <div class="row px-2 py-2 border-bottom" *ngIf="model.getSummary()!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiRitenuta.length > 0 ">
                        <div class="col-12">
                           {{'invoices.edit.riepilogo.restraintData' | translate}}:
                        </div>
                        <div class="col-12 text-right">
                            <span class="d-block" *ngFor="let ritenuta of model.getSummary()!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiRitenuta;"
                                [innerText]='FormatNumber(ritenuta.ImportoRitenuta) +" €"  + " " + ritenuta.TipoRitenuta'><br></span>  
                        </div>
                    </div>

                    <div class="row px-2 py-2 border-bottom" *ngIf="model.getSummary()!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ScontoMaggiorazione.length > 0 ">
                        <div class="col-12">
                           {{'invoices.edit.riepilogo.discountSurchage' | translate}}
                        </div>
                        <div class="col-12 text-right">
                            <span class="d-block" *ngFor="let sconto of model.getSummary()!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.ScontoMaggiorazione;"
                                [innerText]='((sconto.Tipo=="SC") ? "-" : "+") + ((sconto.Importo!="" && sconto.Importo!="0.00")? sconto.Importo : sconto.Percentuale) + ((sconto.Importo!="" && sconto.Importo!="0.00")? " €" : " %")'><br></span>  
                        </div>
                    </div>
                    <div class="row px-2 py-2 border-bottom">
                        <div class="col-12 font-weight-bold">
                            {{'invoices.edit.riepilogo.totalToPay' | translate}}:
                        </div>
                        <div class="col-12 text-right font-weight-bold">
                        <span [innerHTML]="totalePagamento()"></span> €
                        </div>
                    </div>
        </div>
    </div>
</div>